// @ts-nocheck
import React from 'react';
import Pagination from '@mui/material/Pagination';
import makeStyles from '@mui/styles/makeStyles';
import SinapTheme from "../../styles/SinapTheme";

const useStyles = makeStyles(() => ({
    root: {
        '& .Mui-selected': {
            backgroundColor: SinapTheme.palette.primary.main,
            color: 'white'
        }
    }
}));

export default function Paginador({aliasesCount, pageCount, currentPage, setCurrentPage}) {
    const classes = useStyles();
    
    return aliasesCount > 0 &&
        <Pagination
            count={pageCount}
            className={classes.root}
            page={currentPage}
            onChange={(event, page) => {setCurrentPage(page);}}
        />;
};